import {  NotificationTemplateService , BaseTLDetailComponent, AxiosResponse, Component,EnumsService,EnumsFilter } from "../../../Infrastructure/CorBase/CoreBase";

export default abstract class NotificationTemplateDetailBase extends BaseTLDetailComponent {

	returnRoute: string = "NotificationTemplateList";
	notificationTemplateService: NotificationTemplateService = new NotificationTemplateService();	
	enumService: EnumsService = new EnumsService();

	questionDelete = this.$t('notificationTemplate.messageQuestionMain').toString();

	///hlaska o prekroceni inputu po Ctrl+V
	protected infoShortInputBase(maxLength: string): void {
		this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
	}

	getQuestionDelete() {
		return this.formData.existSchoolYear ? this.$t('notificationTemplate.messageQuestionDelete1').toString() : this.$t('notificationTemplate.messageQuestionMain').toString();
	}

	private stateText(name: string): string {
		var e = (document.getElementById(name)) as HTMLSelectElement;
		if (e.selectedOptions[0] == undefined) {
			return 'nic';
		}
		return e.selectedOptions[0].innerText;
	}
	searchAll = [{ id: 1, text: 'test', identifier: '' }];

	initEnum() {
		this.searchAll = [];
		var filter = new EnumsFilter(this.$store.state.idTenant, 'ENU_COR_NotificationTemplate_IvyScreen');
		this.enumService.getAllByFilter(filter).then(res => {
			for (var i = 0; i < res.data.length; i++) {
				this.searchAll.push({ id: res.data[i].id, text: res.data[i].name, identifier: res.data[i].identifier });
				}
		});
	}

	prepareBeforeSave(inputText: string) {
		for (var i = 0; i < this.searchAll.length; i++) {
			inputText = inputText.split('@' + this.searchAll[i].text).join('@' + this.searchAll[i].identifier);
		}
		return inputText;
	}

	prepareAfterLoad(inputText: string) {
		for (var i = 0; i < this.searchAll.length; i++) {
			inputText = inputText.split('@' + this.searchAll[i].identifier).join('@' + this.searchAll[i].text);
		}
		return inputText;
	}

	showDeleteButtonBase() {
		return this.showDeleteButton && this.formData.canDelete;
	}

	showIdentifierFieldBase() {
		return this.formData.identifier != '' && this.formData.identifier != undefined;
	}

	formData = {
		id: 0 as number,
		idTenant: this.$store.state.idTenant,
		studentIsInDebt: false as boolean,
		idTemplateType: -1 as number,
		idTemplateTypeName: '' as string,
		subject: '' as string,
		subjectDtb: '' as string,
		inPriceList: false as boolean,	
		body: '' as string,
		bodyDtb: '' as string,
		isDeleted: false as boolean,
		viaEmail: true as boolean,
		viaPortal: false as boolean,
		existSchoolYear: false as boolean,
		canDelete: false as boolean,
		identifier: '' as string
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		return this.notificationTemplateService.getById(this.objectId);
	}

	protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return super.NoCall()
	}

	protected refreshItems(items: any, refreshData: any): any {
		return items;
	}

	started = false;
	protected processResponse(response: AxiosResponse<any>): void {
		this.formData.id = response.data.id;
		this.formData.idTemplateType = response.data.idTemplateType;
		this.formData.idTemplateTypeName = response.data.idTemplateTypeName;
		this.formData.subjectDtb = response.data.subjectDtb;
		this.formData.studentIsInDebt = response.data.studentIsInDebt;
		this.formData.inPriceList = response.data.inPriceList;
		this.formData.bodyDtb = response.data.bodyDtb;
		this.formData.isDeleted = response.data.isDeleted;
		this.formData.viaEmail = response.data.viaEmail;
		this.formData.viaPortal = response.data.viaPortal;
		this.formData.existSchoolYear = response.data.existSchoolYear;
		this.formData.canDelete = response.data.canDelete;
		this.formData.identifier = response.data.identifier;

		this.formData.body = this.prepareAfterLoad(this.formData.bodyDtb);
		this.formData.subject = this.prepareAfterLoad(this.formData.subjectDtb);
		this.started = true;
	}

	protected afterCreate(response: AxiosResponse<any>): void {
		this.formData.id = response.data.id;
		this.formData.idTemplateTypeName = this.stateText("idTemplateType");
	}

	doAction() {
		super.doCRUDActionWithInfoMessage(this.$t('notificationTemplate.messageNew').toString(), this.$t('notificationTemplate.messageEdit').toString(), this.$t('notificationTemplate.messageDelete').toString());
	}

	protected updateObject(): Promise<AxiosResponse<any>> {
		this.formData.bodyDtb = this.prepareBeforeSave(this.formData.body);
		this.formData.subjectDtb = this.prepareBeforeSave(this.formData.subject);
		return this.notificationTemplateService.update(this.objectId, this.formData);
	}

	protected createObject(): Promise<AxiosResponse<any>> {
		this.formData.bodyDtb = this.prepareBeforeSave(this.formData.body);
		this.formData.subjectDtb = this.prepareBeforeSave(this.formData.subject);
		return this.notificationTemplateService.create(this.formData);
	}

	protected deleteObject(): Promise<AxiosResponse<any>> {
		return this.notificationTemplateService.delete(this.objectId);
	}

	vIsCorrectType: boolean = false;
	vIsCorrectSubject: boolean = false;
	vIsCorrectBody: boolean = false;

	validateBase() {
		return !(
			this.vIsCorrectType &&
			this.vIsCorrectSubject &&
			this.vIsCorrectBody );
	}

	isCorrectTypeBase(value: any) {
		this.vIsCorrectType = this.formData.idTemplateType != 0;
	}

	isCorrectSubjectBase(value: any) {
		this.vIsCorrectSubject = value;
	}

	isCorrectBodyBase(value: any) {
		this.vIsCorrectBody = value;
	}

}
